import React from 'react'
import { connect } from 'react-redux'

import { IIssue, IState } from './types'

import {
  Collapse,
  createStyles,
  IconButton,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Modal,
  Theme,
  Typography,
  withStyles,
  WithStyles,
} from '@material-ui/core'

import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import InfoIcon from '@material-ui/icons/Info'
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore'
import { getIssues } from './selectors'

interface IOwnProps {
  openFileToLine: (params: object) => void
  title: string
}

interface IConnectedProps {
  issues: IIssue[]
}

interface IMenuGroupState {
  collapseIsOpen: boolean
  modalBody: string
  modalOpen: boolean
  modalTitle: string
  showAll: boolean
}

const styles = (theme: Theme) => createStyles({
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 2,
    position: 'absolute',
    width: theme.spacing.unit * 50,
  },
})

interface IThemeProps extends WithStyles<typeof styles> {
  theme: Theme
}

type IMenuGroupProps = IOwnProps & IThemeProps & IConnectedProps

class MenuGroup extends React.Component<IMenuGroupProps, IMenuGroupState> {

  public originalState = {
    collapseIsOpen: false,
    modalBody: '',
    modalOpen: false,
    modalTitle: '',
    showAll: false,
  }

  public state = this.originalState

  protected UNEXPANDED_MAX_ITEMS = 5

  constructor(props: IMenuGroupProps) {
    super(props)
    this.state = this.originalState
  }

  public resetState = () => this.setState(this.originalState)

  public toggleShowAll = () => this.setState(state => ({
    ...state,
    collapseIsOpen: !state.collapseIsOpen ? true : state.collapseIsOpen,
    showAll: !state.showAll,
  }))

  public toggleCollapsed = () => this.setState(state => ({
    ...state,
    collapseIsOpen: !state.collapseIsOpen,
    showAll: state.showAll,
  }))

  public render() {

    const {
      classes,
      issues,
      openFileToLine,
      title,
    } = this.props

    const {
      collapseIsOpen,
      modalBody,
      modalOpen,
      modalTitle,
      showAll,
    } = this.state

    const modalStyle: React.CSSProperties = {
      backgroundColor: 'white',
      left: '50%',
      position: 'absolute',
      top: '50%',
      transform: 'translate(-50%, -50%)',
    }

    return (
      <>
        {!!issues.length && (
          <ListItem dense={true}>
            <ListItemText primary={title} />
            <ListItemSecondaryAction>
              {
                !showAll && issues.length > this.UNEXPANDED_MAX_ITEMS && (
                  <IconButton onClick={this.toggleShowAll} >
                    <UnfoldMoreIcon />
                  </IconButton>
                )
              }
              <IconButton onClick={this.toggleCollapsed} >
                { collapseIsOpen ? <ExpandLess /> : <ExpandMore /> }
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        )}
        <Collapse in={collapseIsOpen} timeout={'auto'} unmountOnExit={true}>
          {
            issues
              .slice(0, showAll ? Infinity : this.UNEXPANDED_MAX_ITEMS)
              .map((issue: IIssue) => (
                <ListItem button={true} component={'a'} dense={true} key={issue.id} onClick={() => openFileToLine(issue)} >
                  <IconButton onClick={() => this.setState({
                    modalBody: issue.info,
                    modalOpen: true,
                    modalTitle: issue.name,
                  })}>
                    <InfoIcon />
                  </IconButton>
                  <ListItemText primary={issue.name} secondary={issue.secondary}/>
                </ListItem>
            ))
          }
        </Collapse>
        <Modal open={modalOpen} onClose={() => this.resetState()} >
          <div style={modalStyle} className={classes.paper}>
            <Typography variant={'title'} style={{ paddingBottom: '20px' }}>{modalTitle}</Typography>
            <Typography variant={'subheading'}>{modalBody}</Typography>
          </div>
        </Modal>
      </>
    )
  }
}

const mapStateToProps = (state: IState, ownProps: { keywords: string[] }) => ({ issues: getIssues(state, ownProps) })

export default connect(mapStateToProps)(withStyles(styles, { withTheme: true })(MenuGroup))



// WEBPACK FOOTER //
// ./src/MenuGroup.tsx